import { createContext, useContext } from "react";
import WorkflowStore from "./workflows.store";
import GlobalStore from "./global.store";
import AccountStore from "./account.store";
import ChannelsStore from "./channels.store";
import CaslStore from "./casl.store";
import CampaignsStore from "./campaigns.store";
import FilesStore from "./files.store";
import ConversationsStore from "./conversations.store";
import { WhatsAppOnboardingStore } from "./whatsapp-onboarding.store";
import EmailStore from "./email.store";
import CalendarStore from "./calendar.store";

interface Store {
  workflowStore: WorkflowStore;
  globalStore: GlobalStore;
  accountStore: AccountStore;
  channelsStore: ChannelsStore;
  caslStore: CaslStore;
  campaignsStore: CampaignsStore;
  filesStore: FilesStore;
  conversationsStore: ConversationsStore;
  whatsappOnboardingStore: WhatsAppOnboardingStore;
  emailStore: EmailStore;
  calendarStore: CalendarStore;
}

// Create CaslStore instance that will be shared across the app
// This must be exported so AuthContext can update permissions on the same instance
export const caslStore = new CaslStore();

export const store: Store = {
  workflowStore: new WorkflowStore(),
  globalStore: new GlobalStore(),
  accountStore: new AccountStore(),
  channelsStore: new ChannelsStore(),
  caslStore: caslStore, // Use the shared instance
  campaignsStore: new CampaignsStore(),
  filesStore: new FilesStore(),
  conversationsStore: new ConversationsStore(),
  whatsappOnboardingStore: new WhatsAppOnboardingStore(),
  emailStore: new EmailStore(),
  calendarStore: new CalendarStore(),
};

// Inject global store reference into conversations store
store.conversationsStore.setGlobalStore(store.globalStore);

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
